import React, { useState } from 'react';
import ReactModal from "react-modal";

function TermsAndConditionsModal(props) {
  const [showModal, setShowModal] = useState(false);

  const { value, onChange } = props;

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleDeny = () => {
    onChange(false);
    setShowModal(false);
  }
  const handleAccept = () => {
    onChange(true);
    setShowModal(false);
  }

  return (
    <>
      <label className="inline-flex items-center py-1 mt-3">
        <input
          type="checkbox"
          className="form-checkbox h-4 w-4 "
          checked={value}
          onChange={handleShow}
        />
        <span className="ml-2 text-primary-color text-sm font-sf-light">I accept Trayvo Terms and Conditions.</span>
      </label>
      {<ReactModal
        isOpen={showModal}
        onRequestClose={handleClose}>

        <div className="modal-header flex items-center flex-col p-2 bg-white rounded-md max-70-vh">
          <button className='hover:bg-secondary text-blue-900 text-sm hover:text-blue-500 py-2 px-2 rounded absolute top-1 right-1 font-bold focus:outline-none'
            onClick={handleClose}>
            <svg className="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
            </svg>
          </button>
          <h2 className="w-100 text-xl text-center">Terms And Conditions</h2>
        </div>

        <div className="modal-body">
          <div className="w-full font-normal text-justify">
            <p className="mb-2">
              In consideration of being allowed to participate in any way and/or engage in training activities through the trayvo booking platform and / or with any trainer registered on the trayvo booking platform or involved with any camp or training session, the person accepting this electronic waiver:
            </p>
            <p className="mb-2">
              1. Acknowledge and fully understand that each participant will be engaging in activities that involve risk of serious injury, including permanent disability, paralysis and death, as well as other damages and losses associated with participation in training practices, camps, clinics, tournaments and/or recruiting showcases. These risks may result from their own actions, inactions or negligence of others, or the condition of the premises or of any equipment used;
            </p>
            <p className="mb-2">
              2. Assume all the foregoing risks and accept personal responsibility for any and all damages or costs following such injury, permanent disability or death;
            </p>
            <p className="mb-2">
              3. Release, waive, discharge and covenant not to sue trayvo, GAL Holdings or any trainer / athlete registered on the trayvo booking platform, or their affiliated camps, tournaments/showcases, their respective owners, members, administrators, directors, coaches and other employees and independent contractors of said organization, participants, sponsoring agencies, sponsors, advertisers, and, if applicable, owners and lessees of premises used to conduct training related events, all of which are hereinafter referred to as "releases", from demand, losses or damages on account of injury, including death or damage to property, caused or alleged to be caused in whole or in part by the negligence of the releases or otherwise;
            </p>
            <p className="mb-2">
              4. Shall defend, indemnify, and hold trayvo, GAL Holdings or any trainer registered on the trayvo booking platform, its officers, owners, employees, independent contractors and agents harmless from and against any and all liability, loss, expense, including reasonable attorneys' fees, or claims for injury or damages arising out of the performance of this Agreement;
            </p>
            <p className="mb-2">
              5. I hereby give my consent to trayvo, GAL Holdings or any trainer registered on the trayvo booking platform, the owners and operators of trayvo, GAL Holdings or any trainer registered on the trayvo booking platform and all other Covered Parties to provide, through medical staff of its choice, customary medical/athletic training attention, transportation and emergency medical services as warranted in the course of my participation in activities related to training practices, clinics, tournaments, and/or recruiting showcases. Notwithstanding the foregoing, I understand and agree that none of the Covered Parties have any obligation to provide any such medical/athletic training attention and the lack of any such medical/athletic training attention or the provision thereof on a voluntary basis shall be covered by the waiver and release set forth in this paragraph. It is expressly understood that medical and/or accident insurance for participant is provided by the participant and/or parent/guardian, and is not in any way provided by trayvo, GAL Holdings or any trainer registered on the trayvo booking platform, its owners or officers.
            </p>
            <p className="mb-2">
              6. I understand that trayvo, GAL Holdings or any trainer registered on the trayvo booking platform may use photographs and/or video of any trayvo training session for promotional purposes.  I grant trayvo, GAL Holdings or any trainer registered on the trayvo booking platform permission to use the participating student athlete's name, image, voice, video and identity in any program for promotion of trayvo trainings / camps and its affiliate organizations to include, but not limited to, written materials, website materials, video, audio, or other forms.
            </p>
            <p className="mb-2">
              THE PERSON ACCEPTING THIS ELECTRONIC WAIVER HAS READ AND ACKNOWLEDGES THAT HE/SHE IS ENTERING INTO THE ABOVE WAIVER AND RELEASE, UNDERSTANDING THAT THEY HAVE GIVEN UP SUBSTANTIAL RIGHTS BY ELECTRONICALLY SIGNING IT AND ELECTRONICALLY SIGN IT VOLUNTARILY. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, IT IS MY INTENTION ON BEHALF OF MYSELF OR MY MINOR CHILD TO SPECIFICALLY RELEASE AND INDEMNIFY TRAYVO, GAL HOLDINGS OR ANY TRAINER REGISTERED ON THE TRAYVO BOOKING PLATFORM, ITS ADMINISTRATORS, OWNERS, DIRECTORS, COACHES, INDEPENDENT CONTRACTORS AND OTHER EMPLOYEES OF SAID ORGANIZATION FROM ANY AND ALL CLAIMS ARISING FROM THEIR OWN NEGLIGENCE. I AGREE TO INDEMNIFY, DEFEND AND HOLD HARMLESS TRAYVO, GAL HOLDINGS OR ANY TRAINER REGISTERED ON THE TRAYVO BOOKING PLATFORM, ITS ADMINISTRATORS, OWNERS, DIRECTORS, COACHES, INDEPENDENT CONTRACTORS AND OTHER EMPLOYEES OF SAID ORGANIZATION FROM ANY LIABILITIES, LOSSES, DAMAGES, SETTLEMENTS, CLAIMS, EXPENSES AND COSTS ARISING FROM MY OR MY CHILDS PARTICIPATION IN THE DESCRIBED ACTIVITY, SAID INDEMNITY TO INCLUDE COURT COSTS, MEDICAL EXPENSES AND REASONABLE ATTORNEYS FEES.
            </p>
          </div>
        </div>

        <div className="modal-footer">
          <button
            onClick={handleDeny}
            className="secondary-button w-full md:w-32 mr-0 md:mr-3"
            type="button">
            Deny
          </button>
          <button
            onClick={handleAccept}
            className="primary-button w-full md:w-32 mr-0 md:mr-3"
            type="button">
            Accept
          </button>
        </div>
      </ReactModal>
      }
    </>
  );
}

export default TermsAndConditionsModal;
